import React from 'react';
import { cn } from '@/utils/cn';
import Image from '@/components/common/Image';

interface ComplianceBadgeCardProps extends React.HTMLAttributes<HTMLDivElement> {
  logo: string;
  title: string;
  backgroundColor?: string;
  iconWidth?: number;
  iconHeight?: number;
}

const ComplianceBadgeCard = ({
  logo,
  title,
  backgroundColor,
  iconWidth = 80,
  iconHeight = 80,
  className,
  ...props
}: ComplianceBadgeCardProps) => {
  return (
    <div
      className={cn("flex flex-col items-center justify-center text-center", className)}
      {...props}
    >
      <div className="mb-3">
        <Image
          src={logo}
          alt={`${title} certification`}
          width={iconWidth}
          height={iconHeight}
          className="md:w-[120px] md:h-[120px]"
        />
      </div>

      <h3 className="text-base font-medium text-blue-500">{title}</h3>
    </div>
  );
};

export default ComplianceBadgeCard;